






































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Skill from "../../models/skill";
import UserExam from "../../models/user_exam";
import SkillItem from "../../models/skill_item";

@Component({})
export default class SkillsChart extends Vue {
  @Prop({ required: true }) userExam: UserExam
  @Prop({ required: true }) skills: Skill[]

  skillScore(skillItem: SkillItem) {
    return Math.round(skillItem.getCurrentAverage(this.userExam) * 10) / 10
  }
}
